/* eslint-disable */
import React, {useEffect, useRef, useState} from 'react';
import cn from 'classnames';
import {useHistory, useLocation, useRouteMatch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
import {toast} from 'react-toastify';
import IconStar from '@material-ui/icons/Star';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {
  ElevatedPaper,
  FlexContainer,
  FlexItem,
  TopLineNav
} from 'components/layout';
import {ButtonPrimary} from 'components/buttons';
import {Body1, Caption1, Subtitle2} from 'components/typography';
import {
  BillSection,
  EtaClock,
  OrderDetailsHeader,
  OrderRBottom,
  OrderRSide,
  OrderRTop,
  ProofOfDeliveryButton,
  StatusRow
} from 'routes/App/ordersV2/OrderDetails/styles';
import {FieldTextarea} from 'routes/App/dashboard/styles';
import PrinterIcon from 'assets/IconPrinter';
import {
  CHANGE_STATUS,
  CLEAR_ORDER,
  GET_DELIVERY_STATUS,
  GET_DISPATCH_INFO,
  GET_DRIVER_RATING,
  GET_ORDER,
  GET_ORDER_SUCCESS,
  OPEN_CANCEL_DELIVERY_ORDER_MODAL
} from 'store/ordersV2/orderDetails/action';
import Loading from 'components/shared/Utils/Loading';
import {CHANGE_ORDER_INFO} from 'store/orders/orderList/action';
import Bill from 'routes/App/ordersV2/components/Bill';
import LinkBack from 'components/LinkBack/styles';
import ButtonOutline from 'components/buttons/ButtonOutline/styles';
import useNetwork from 'hooks/useNetwork';
import PulsatingDot from 'components/PulsatingDot';
import {
  ORDER,
  ORDER_SOURCE,
  AVAILABLE_ORDER_STATUSES,
  ORDER_STATUS,
  ORDER_CHANNELS,
  ORDER_TYPE,
  DELIVERY_PROVIDER_TYPE,
  DELIVERY_STATUS,
  isDeliveryRateableStatus
} from 'helpers/constants/orders_v2';
import StatusButton from 'routes/App/ordersV2/OrdersList/components/StatusButton';
import {
  checkIsBaDPOS,
  checkIsFullRefundOrder,
  checkIsFutureOrder,
  checkIsPossibleToCancelByocDelivery,
  checkIsPossibleToCancelDriver,
  formattedOrderForBaD,
  getConfirmedPriceAdjustmentsForOrderNote,
  getGrubHubPendingRequestNotes,
  getGrubHubRejectedRequestNotes,
  getOrderRefundHistoryDisplayItems,
  grubHubBlocksFurtherRefundAdjust,
  isPickupReadyButtonDisabled,
  shouldShowByocTrackDelivery,
  shouldShowPickupReadyUi
} from 'helpers/functionUtils/ordersUtilsV2';
import DashboardContent from 'components/DashboardContent/styles';
import DashboardInner from 'components/DashboardInner/styles';
import {phoneFormatForView} from 'helpers/functionUtils/helpFunctions';
import {usePrevious} from 'hooks/usePrevious';
import IconCar from 'assets/IconCar';
import {SET_BAD_ORDER_DETAIL} from 'store/bookADriver/bookADriverCreate/action';
import {
  checkIfSauceEmployee,
  FEATURE_RESTRICTION_IDS,
  getBookADriverRestriction,
  hasBookADriverAccess,
  STRIPE_ACCOUNT_RESTRICTION_NAMES
} from 'helpers/constants/restrictions';
import RestrictedArea from 'components/layout/RestrictedArea';
import IconDollarRefund from 'assets/IconDollarRefund';
import {CLEAR_REFUND_DATA} from 'store/ordersV2/orderRefund/action';
import IconRefundOrderDetails from 'assets/IconRefundOrderDetails';
import {getSessionStorageItem} from 'helpers/sessionStorage';
import SESSION_SAUCE_EMPLOYEE_NAME from 'helpers/sessionStorage/constants';
import IconOrderAdjustment from 'assets/icon-order-adjustment.svg';
import IconOrderAdjust from 'assets/IconOrderAdjust';
import {OPEN_ADJUST_MODAL} from 'store/ordersV2/orderAdjust/action';
import AdjustOrderModal from 'routes/App/ordersV2/OrderDetails/Adjust';
import AdjustSuccessModal from 'routes/App/ordersV2/OrderDetails/Adjust/Modals/AdjustSuccessModal';
import AdjustErrorModal from 'routes/App/ordersV2/OrderDetails/Adjust/Modals/AdjustErrorModal';
import {OPEN_CANCELLATION_CONFIRMATION_MODAL_V2} from 'store/global/modals/action';
import CancelDeliveryOrderModal from 'routes/App/ordersV2/modals/CancelDeliveryOrderModal';
import CancelDeliveryOrderResultModal from 'routes/App/ordersV2/modals/CancelDelivaryOrderResultModal';
import InfoModal from 'routes/App/ordersV2/modals/InfoModal/InfoModal';
import RateDriverModal from 'routes/App/ordersV2/modals/RateDriverModal';
import DriverRatingViewModal from 'routes/App/ordersV2/modals/DriverRatingViewModal';
import ProofOfDeliveryModal from 'routes/App/ordersV2/modals/ProofOfDeliveryModal';
import IconProofOfDelivery from 'assets/IconProofOfDelivery';
import IconRedCheck from 'assets/icon-red-check.svg';
import LargeDeliveryBanner from 'routes/App/ordersV2/OrderDetails/LargeDeliveryBanner';
import DriverOptOut from 'routes/App/ordersV2/OrderDetails/DriverOptOut';
import SelfDeliveryNote from 'routes/App/ordersV2/OrderDetails/DriverOptOut/SelfDeliveryNote';
import useHybridHoldRefresh from 'routes/App/ordersV2/OrderDetails/DriverOptOut/useHybridHoldRefresh';
import {isSauceDriverPending} from 'helpers/functionUtils/hybridDelivery';

export default function OrderDetails() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const {params} = useRouteMatch();
  const [isOnline] = useNetwork();

  const {
    order,
    loading,
    dispatchInfo,
    changeStatusLoading,
    deliveryStatus,
    isOpenCancelDeliveryOrderModal,
    loadingCancellation,
    deliveryCancellationResult,
    driverRating,
    getDriverRatingLoading,
    deliveryStatusLoading
  } = useSelector(({orderDetailsV2Reducer}) => ({
    loading: orderDetailsV2Reducer.loading,
    order: orderDetailsV2Reducer.order,
    dispatchInfo: orderDetailsV2Reducer.dispatchInfo,
    changeStatusLoading: orderDetailsV2Reducer.changeStatusLoading,
    deliveryStatus: orderDetailsV2Reducer.deliveryStatus,
    isOpenCancelDeliveryOrderModal:
      orderDetailsV2Reducer.isOpenCancelDeliveryOrderModal,
    loadingCancellation: orderDetailsV2Reducer.loadingCancellation,
    deliveryCancellationResult:
      orderDetailsV2Reducer.deliveryCancellationResult,
    driverRating: orderDetailsV2Reducer.driverRating,
    getDriverRatingLoading: orderDetailsV2Reducer.getDriverRatingLoading,
    deliveryStatusLoading: orderDetailsV2Reducer.deliveryStatusLoading
  }));
  const {locationName, activeLocation, locationId} = useSelector(
    (state) => state.user
  );

  const serviceFeatures = useSelector(
    (state) => state.user?.activeLocation?.AllowedServiceFeatures
  );
  const showOtterBrandName = serviceFeatures?.includes(
    FEATURE_RESTRICTION_IDS.OTTER_SHOW_BRAND_NAME
  );

  const {isNetworkOnline} = useSelector(
    (state) => state.globalNotificationsReducer
  );

  const {
    isOpenAdjustModal,
    isOpenSuccessModal,
    isOpenErrorModal,
    errorMessage,
    errorTitle
  } = useSelector((state) => state.orderAdjustV2Reducer);

  const prevLocation = usePrevious(locationId);

  const redirectToPreviousRoute = (state = {}) => {
    dispatch(CLEAR_ORDER());
    history.push(
      params.back === 'history' ? '/orders-v2/history' : '/orders-v2/active',
      state
    );
  };
  const redirectToRefundRoute = (orderId, tier1Redirect = false) => {
    dispatch(CLEAR_REFUND_DATA());
    history.push({
      pathname:
        params.back === 'history'
          ? `/orders-v2/history/${orderId}/details/refund`
          : `/orders-v2/active/${orderId}/details/refund`
    });
  };

  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [isRateDriverModalOpen, setIsRateDriverModalOpen] = useState(false);
  const [
    isDriverRatingViewModalOpen,
    setIsDriverRatingViewModalOpen
  ] = useState(false);
  const [isProofOfDeliveryModalOpen, setIsProofOfDeliveryModalOpen] = useState(
    false
  );

  useEffect(() => {
    if (prevLocation) {
      redirectToPreviousRoute();
    }
  }, [locationId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (order.id !== params.id) {
      dispatch(GET_ORDER(params.id));
    }

    //TODO: Very dirty hack to avoid details clearing after back from refunds
    // needed to be refactored
    // return () => {
    //   dispatch(ORDER_UNMOUNT());
    // };
  }, []);

  // useEffect(() => {
  //   if (order.InternalNotes) {
  //     setNotesValue(order.InternalNotes);
  //   }
  // }, [order.InternalNotes]);

  useEffect(() => {
    if (
      (order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE || checkIsBaDPOS(order)) &&
      order[ORDER.DELIVERY]?.id &&
      isOnline
    ) {
      dispatch(GET_DELIVERY_STATUS(order[ORDER.DELIVERY]?.id));
      dispatch(GET_DISPATCH_INFO(order[ORDER.DELIVERY]?.id));
      dispatch(GET_DRIVER_RATING(order[ORDER.DELIVERY]?.id));
    }
  }, [order[ORDER.DELIVERY]?.id, isOnline]);

  const [locationState] = useState(location?.state?.windowPosition);

  const ref = useRef();

  const [showAdjustRefundSelector, setShowAdjustRefundSelector] = useState(
    false
  );

  const onStatusChange = (
    id,
    status,
    previousStatus,
    deliveryProvider,
    source
  ) => {
    if (status !== previousStatus && !changeStatusLoading && isNetworkOnline) {
      if (status === ORDER_STATUS.CANCELLED) {
        dispatch(
          OPEN_CANCELLATION_CONFIRMATION_MODAL_V2({
            isOpen: true,
            info: {id, status, previousStatus, location: params.back, source},
            source: 'details',
            deliveryProvider
          })
        );
      } else {
        dispatch(
          CHANGE_STATUS({id, status, previousStatus, location: params.back})
        );
      }
    }
  };

  useHybridHoldRefresh(order, serviceFeatures, () =>
    dispatch(GET_ORDER({id: params.id, silent: true}))
  );

  // The switch to own driver can finish after the merchant opened another order;
  // its result must not replace that order on screen.
  const openOrderIdRef = useRef(params.id);
  openOrderIdRef.current = params.id;
  // Leaving the details page unmounts it, so a later callback must not match.
  useEffect(() => {
    openOrderIdRef.current = params.id;
    return () => {
      openOrderIdRef.current = null;
    };
  }, [params.id]);
  const switchedOrderId = params.id;

  const refreshOrder = (converted) => {
    if (openOrderIdRef.current !== switchedOrderId) return;
    if (converted) {
      dispatch(
        GET_ORDER_SUCCESS({
          order: {Timezone: order?.Timezone, ...converted},
          PickupReadyEnabled: activeLocation?.PickupReadyEnabled,
          serviceFeatures
        })
      );
      return;
    }
    dispatch(GET_ORDER(params.id));
  };

  const onPickupReady = (id, status, previousStatus) => {
    if (status !== previousStatus && !changeStatusLoading && isNetworkOnline) {
      dispatch(
        CHANGE_STATUS({id, status, previousStatus, location: params.back})
      );
    }
  };

  const checkIfSauceEmployee = () => {
    return getSessionStorageItem(SESSION_SAUCE_EMPLOYEE_NAME);
  };

  const sendDriverRateToPostHog = (action, data) => {
    if (window?.posthog) {
      window?.posthog.capture('driver_rate_action', {
        order_id: order[ORDER.ID],
        action,
        rating_type: data?.ratingType,
        selected_reasons: data?.selectedReasons?.join(', '),
        details: data?.details,
        location_id: data?.locationId,
        location_name: data?.locationName,
        timestamp: moment().utc().format()
      });
    }
  };

  const grubHubFurtherActionsBlocked = grubHubBlocksFurtherRefundAdjust(order);
  const isOrderCancelled = order[ORDER.ORDER_STATUS] === ORDER_STATUS.CANCELLED;
  const grubHubRefundAdjustUnavailable =
    order[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB &&
    order[ORDER.CHANNEL] === ORDER_CHANNELS.GRUBHUB &&
    (isOrderCancelled || grubHubFurtherActionsBlocked);
  const grubHubPendingNotes = getGrubHubPendingRequestNotes(order);
  const grubHubRejectedNotes = getGrubHubRejectedRequestNotes(order);
  const confirmedAdjustmentsForNote = getConfirmedPriceAdjustmentsForOrderNote(
    order
  );
  const refundHistoryItems = getOrderRefundHistoryDisplayItems(order);

  const showRateDriverButton =
    order[ORDER.DELIVERY]?.id &&
    deliveryStatus?.status &&
    isDeliveryRateableStatus(
      deliveryStatus.status,
      deliveryStatus?.courier?.name
    );

  const showProofOfDeliveryButton =
    serviceFeatures?.includes(FEATURE_RESTRICTION_IDS.SHOW_PROOF_OF_DELIVERY) &&
    deliveryStatus?.status === DELIVERY_STATUS.DELIVERED &&
    Boolean(deliveryStatus?.proofOfDelivery?.photoUrl);

  return (
    <DashboardContent className='DashboardContent'>
      <TopLineNav>
        <LinkBack
          onClick={() => {
            redirectToPreviousRoute({windowPosition: locationState});
          }}
        >
          Back To All Orders
        </LinkBack>
      </TopLineNav>
      <DashboardInner className='orderDetailsPaddingBottom'>
        {loading || getDriverRatingLoading || deliveryStatusLoading ? (
          <Loading />
        ) : (
          <>
            <OrderDetailsHeader className='marginBottomMd alignItemsStart'>
              <div className='OrderDetailsActions'>
                <DriverOptOut order={order} onSwitched={refreshOrder} />
                <RestrictedArea
                  restrictions={[]}
                  features={[FEATURE_RESTRICTION_IDS.REFUNDS]}
                  extraAccessLogic={() =>
                    activeLocation.StripeAccountType !==
                      STRIPE_ACCOUNT_RESTRICTION_NAMES.CONNECTED_STANDARD &&
                    (order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE ||
                      (order[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB &&
                        order[ORDER.CHANNEL] === ORDER_CHANNELS.GRUBHUB))
                  }
                >
                  {!checkIfSauceEmployee() &&
                    order[ORDER.CHANNEL] !== ORDER_CHANNELS.STREAM_EVENT &&
                    order[ORDER.CHANNEL] !== ORDER_CHANNELS.SPOTON &&
                    order[ORDER.SOURCE] !== ORDER_SOURCE.OTTER && (
                      <ButtonOutline
                        className={cn(
                          'ButtonSmall marginRightMd buttonRefund',
                          {
                            disabledRefundButton:
                              checkIsFullRefundOrder(order) ||
                              grubHubRefundAdjustUnavailable
                          }
                        )}
                        onClick={() => {
                          if (grubHubRefundAdjustUnavailable) {
                            return;
                          }
                          if (checkIsFullRefundOrder(order)) {
                            return;
                          }
                          if (
                            order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE ||
                            (order[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB &&
                              order[ORDER.CHANNEL] === ORDER_CHANNELS.GRUBHUB)
                          ) {
                            redirectToRefundRoute(order[ORDER.ID], false);
                          } else {
                            setOpenInfoModal(true);
                          }
                        }}
                        withIcon
                      >
                        <IconDollarRefund />
                        Refund
                      </ButtonOutline>
                    )}
                </RestrictedArea>
                <RestrictedArea
                  restrictions={[]}
                  features={[FEATURE_RESTRICTION_IDS.PAYMENT_ADJUSTMENT]}
                  extraAccessLogic={() =>
                    (order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE ||
                      (order[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB &&
                        order[ORDER.CHANNEL] === ORDER_CHANNELS.GRUBHUB)) &&
                    order[ORDER.CHANNEL] !== ORDER_CHANNELS.STREAM_EVENT &&
                    order[ORDER.CHANNEL] !== ORDER_CHANNELS.SPOTON
                  }
                >
                  <ButtonOutline
                    className={cn('ButtonSmall marginRightMd buttonRefund', {
                      disabledRefundButton: grubHubRefundAdjustUnavailable
                    })}
                    onClick={() => {
                      if (grubHubRefundAdjustUnavailable) {
                        return;
                      }
                      if (
                        order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE ||
                        (order[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB &&
                          order[ORDER.CHANNEL] === ORDER_CHANNELS.GRUBHUB)
                      ) {
                        dispatch(OPEN_ADJUST_MODAL(true));
                      } else {
                        setOpenInfoModal(true);
                      }
                    }}
                    withIcon
                  >
                    <IconOrderAdjust />
                    <span>Adjust</span>
                  </ButtonOutline>
                </RestrictedArea>

                {(order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE ||
                  shouldShowByocTrackDelivery(order, serviceFeatures) ||
                  (order[ORDER.CHANNEL] === ORDER_CHANNELS.STREAM_EVENT &&
                    order[ORDER.DELIVERY]?.locationTrackingUrl)) && (
                  <ButtonOutline
                    data-gtm={'trackDeliveryButton'}
                    className={cn('ButtonSmall', {
                      disabled: !order[ORDER.DELIVERY]?.locationTrackingUrl
                    })}
                    onClick={() => {
                      if (order[ORDER.DELIVERY]?.locationTrackingUrl) {
                        window.open(
                          order[ORDER.DELIVERY]?.locationTrackingUrl,
                          '_blank'
                        );
                      }
                    }}
                  >
                    Track Delivery
                  </ButtonOutline>
                )}

                <ReactToPrint
                  pageStyle={`
                  @media print {
                    html, body {
                      width: 80mm;
                      background-color: white !important;
                       }
                      }  
                    `}
                  trigger={() => (
                    <ButtonOutline
                      className='ButtonSmall secondary'
                      data-gtm='printButton'
                      withIcon
                    >
                      <PrinterIcon data-gtm='printButton' />
                      Print 80mm
                    </ButtonOutline>
                  )}
                  content={() => ref.current}
                />
                {showRateDriverButton && (
                  <ButtonOutline
                    className={cn('ButtonSmall withIcon', {
                      smallP: !driverRating?.id
                    })}
                    onClick={() => {
                      if (driverRating?.id) {
                        setIsDriverRatingViewModalOpen(true);
                      } else {
                        setIsRateDriverModalOpen(true);
                      }
                    }}
                    withIcon
                  >
                    {driverRating?.id ? (
                      <>
                        <img src={IconRedCheck} alt='Check' />
                        <span>Driver Rated</span>
                      </>
                    ) : (
                      <>
                        <IconStar />
                        <span>Rate Driver</span>
                      </>
                    )}
                  </ButtonOutline>
                )}
              </div>
              <div style={{display: 'flex'}}>
                {/* No Ready while Sauce has yet to book the driver: there is no
                    courier to hand the order to, as in the list's opt-out cell. */}
                {!isSauceDriverPending(order, serviceFeatures) &&
                  shouldShowPickupReadyUi(
                    order,
                    activeLocation?.PickupReadyEnabled,
                    serviceFeatures
                  ) && (
                    <ButtonPrimary
                      className={cn('ButtonMedium mRight20', {
                        disabledWithClick: isPickupReadyButtonDisabled(
                          order,
                          activeLocation?.PickupReadyEnabled,
                          serviceFeatures
                        )
                      })}
                      onClick={() => {
                        if (
                          isPickupReadyButtonDisabled(
                            order,
                            activeLocation?.PickupReadyEnabled,
                            serviceFeatures
                          )
                        ) {
                          toast.error(
                            'Cannot do pickup ready. Expect the courier within pickup ETA.'
                          );
                        } else {
                          onPickupReady(
                            order[ORDER.ID],
                            ORDER_STATUS.READY,
                            order[ORDER.ORDER_STATUS]
                          );
                        }
                      }}
                    >
                      <span>Ready</span>
                    </ButtonPrimary>
                  )}
                <RestrictedArea
                  restrictions={[]}
                  features={
                    checkIfSauceEmployee()
                      ? []
                      : [getBookADriverRestriction(serviceFeatures)].filter(
                          Boolean
                        )
                  }
                  extraAccessLogic={() =>
                    !isSauceDriverPending(order, serviceFeatures)
                  }
                >
                  <ButtonPrimary
                    data-gtm='bookADriverButton'
                    onClick={() => {
                      dispatch(
                        SET_BAD_ORDER_DETAIL(formattedOrderForBaD(order))
                      );
                      history.push(`/book-a-driver/create-order`, {
                        windowPosition: window.scrollY
                      });
                    }}
                    className='ButtonMedium ButtonDriver'
                  >
                    <IconCar data-gtm='bookADriverButton' />
                    <span data-gtm='bookADriverButton'>Book a Driver</span>
                  </ButtonPrimary>
                </RestrictedArea>
              </div>
            </OrderDetailsHeader>
            <>
              {checkIsFutureOrder(order) && (
                <div className='marginBottomSm'>
                  <PulsatingDot
                    classNameDot='orderDetails'
                    classNamePulsating='orderDetails'
                  />
                  <Subtitle2 className='marginLeft2l'>
                    <b>Note</b>: this is a future order. ETA is{' '}
                    <b>
                      {moment(`${order[ORDER.DATE]}Z`)
                        .utcOffset(0)
                        .format('MMMM D, h:mm A')}
                    </b>
                  </Subtitle2>
                </div>
              )}
              {order[ORDER.SOURCE] === ORDER_SOURCE.GRUBHUB &&
                order[ORDER.CHANNEL] === ORDER_CHANNELS.GRUBHUB &&
                grubHubFurtherActionsBlocked &&
                !isOrderCancelled && (
                  <div className='marginBottomSm'>
                    <Subtitle2>
                      This order has already been adjusted. No further refunds
                      or adjustments can be made.
                    </Subtitle2>
                  </div>
                )}
              {/* {grubHubRejectedNotes.map((text) => (
                <div className='marginBottomSm' key={`rejected-${text}`}>
                  <Subtitle2>{text}</Subtitle2>
                </div>
              ))} */}
              {grubHubPendingNotes.map((text) => (
                <div className='marginBottomSm' key={`pending-${text}`}>
                  <Subtitle2>{text}</Subtitle2>
                </div>
              ))}
              {Array.isArray(confirmedAdjustmentsForNote) &&
                confirmedAdjustmentsForNote.length > 0 && (
                  <div className='marginBottomXl orderDetailsRefund'>
                    <img src={IconOrderAdjustment} alt='Adj' />
                    <Subtitle2>
                      Order total was <b>adjusted </b>
                      on{' '}
                      {moment(
                        confirmedAdjustmentsForNote[
                          confirmedAdjustmentsForNote.length - 1
                        ]?.createdAt
                      )
                        .utcOffset(activeLocation?.Timezone, false)
                        .utc()
                        .format('DD MMMM YYYY')}
                    </Subtitle2>
                  </div>
                )}
              {Array.isArray(refundHistoryItems) &&
                refundHistoryItems.length > 0 &&
                refundHistoryItems.map((item, idx) => (
                  <div
                    className='marginBottomXl orderDetailsRefund'
                    key={`${item?.createdAt}-${item?.type}-${idx}`}
                  >
                    <IconRefundOrderDetails />
                    <Subtitle2>
                      This order was{' '}
                      <b>
                        {item?.type === 'Full' ? 'fully' : 'partially'} refunded{' '}
                      </b>
                      on{' '}
                      {moment(item?.createdAt)
                        .utcOffset(activeLocation?.Timezone || 0, false)
                        .utc()
                        .format('DD MMMM YYYY')}
                    </Subtitle2>
                  </div>
                ))}
              {deliveryStatus?.status === 'Canceled' && (
                <div className='marginBottomXl'>
                  <Subtitle2>
                    Order delivery has been <b>canceled</b>
                    {deliveryStatus?.lastUpdateDate && (
                      <>
                        {' '}
                        on{' '}
                        {moment(deliveryStatus?.lastUpdateDate)
                          .utcOffset(activeLocation?.Timezone || 0, false)
                          .utc()
                          .format('DD MMMM YYYY')}
                      </>
                    )}
                  </Subtitle2>
                </div>
              )}

              {checkIsBaDPOS(order) &&
                !order[ORDER.DELIVERY]?.locationTrackingUrl && (
                  <div className='marginBottomXl'>
                    <Subtitle2>
                      Tracking link will appear here soon. Please contact
                      support if you have any questions.
                    </Subtitle2>
                  </div>
                )}

              <FlexContainer className='OrderDetails'>
                <FlexItem className='OrderDetailsLside'>
                  <BillSection>
                    <ElevatedPaper>
                      <Bill
                        order={order}
                        locationName={locationName}
                        timezone={activeLocation.Timezone}
                        allowedServiceFeatures={serviceFeatures}
                        showOtterBrandName={showOtterBrandName}
                      />
                    </ElevatedPaper>
                  </BillSection>
                  <div style={{display: 'none'}}>
                    <Bill
                      ref={ref}
                      order={order}
                      locationName={locationName}
                      useSalesPackage={activeLocation.UseSalesPackage}
                      timezone={activeLocation.Timezone}
                      allowedServiceFeatures={serviceFeatures}
                      showOtterBrandName={showOtterBrandName}
                    />
                  </div>
                </FlexItem>
                <FlexItem className='wAutoSpace'>
                  <OrderRSide>
                    <OrderRTop>
                      <SelfDeliveryNote order={order} />
                      <LargeDeliveryBanner order={order} />
                      <Body1 className='block marginBottomLg'>
                        <StatusRow>
                          <div
                            style={
                              !isNetworkOnline ||
                              changeStatusLoading ||
                              order[ORDER.ORDER_STATUS] ===
                                ORDER_STATUS.CANCELLED
                                ? {opacity: '0.5', pointerEvents: 'none'}
                                : null
                            }
                          >
                            <StatusButton
                              status={order[ORDER.ORDER_STATUS]}
                              order={order}
                              onStatusChange={(status) => {
                                onStatusChange(
                                  order[ORDER.ID],
                                  status,
                                  order[ORDER.ORDER_STATUS],
                                  order[ORDER.DELIVERY]?.isDispatch,
                                  order[ORDER.SOURCE]
                                );
                              }}
                              pickupReadyEnabled={
                                activeLocation?.PickupReadyEnabled
                              }
                              serviceFeatures={serviceFeatures}
                            />
                          </div>
                          {showProofOfDeliveryButton && (
                            <ProofOfDeliveryButton
                              type='button'
                              onClick={() =>
                                setIsProofOfDeliveryModalOpen(true)
                              }
                            >
                              <IconProofOfDelivery />
                              <span>View proof of delivery</span>
                            </ProofOfDeliveryButton>
                          )}
                        </StatusRow>
                      </Body1>

                      {deliveryStatus?.status &&
                        (checkIsPossibleToCancelDriver(order) ||
                          checkIsPossibleToCancelByocDelivery(
                            order,
                            serviceFeatures
                          )) &&
                        !(
                          order[ORDER.ORDER_TYPE] === ORDER_TYPE.DELIVERY &&
                          order[ORDER.DELIVERY]?.provider ===
                            DELIVERY_PROVIDER_TYPE.LOCATION
                        ) &&
                        AVAILABLE_ORDER_STATUSES.includes(
                          deliveryStatus?.status
                        ) && (
                          <Body1 className='block marginBottomLg'>
                            <ButtonOutline
                              onClick={() => {
                                if (
                                  order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE ||
                                  checkIsBaDPOS(order)
                                ) {
                                  dispatch(
                                    OPEN_CANCEL_DELIVERY_ORDER_MODAL(true)
                                  );
                                } else {
                                  setOpenInfoModal(true);
                                }
                              }}
                              className='ButtonSmall'
                            >
                              Cancel driver
                            </ButtonOutline>
                          </Body1>
                        )}

                      <Body1 className='block marginBottomLg'>
                        <EtaClock className='inlineBlock marginRightXs'>
                          ETA:
                        </EtaClock>
                        <strong>
                          {order[ORDER.DATE] &&
                            moment(`${order[ORDER.DATE]}Z`)
                              .utcOffset(0)
                              .format('MMMM D, h:mm A')}
                        </strong>
                      </Body1>

                      <Body1 className='block marginBottomLg'>
                        <span className='inlineBlock marginRightXs'>
                          Delivery address:
                        </span>
                        <strong>
                          {order[ORDER.DELIVERY]?.address?.formattedAddress ||
                            'N/A'}
                        </strong>
                      </Body1>

                      {(order[ORDER.DELIVERY]?.address?.apt ||
                        order[ORDER.DELIVERY]?.address?.unit ||
                        order[ORDER.DELIVERY]?.address?.entrance ||
                        order[ORDER.DELIVERY]?.address?.floor ||
                        order[ORDER.DELIVERY]?.address?.notes) && (
                        <Body1 className='block marginBottomLg'>
                          <span className='inlineBlock marginRightXs'>
                            Delivery details:
                          </span>
                          <br />
                          <span>
                            {order[ORDER.DELIVERY]?.address?.unit && (
                              <>
                                Unit:{' '}
                                <strong>
                                  {order[ORDER.DELIVERY]?.address?.unit}
                                </strong>{' '}
                              </>
                            )}
                            {order[ORDER.DELIVERY]?.address?.apt && (
                              <>
                                Apt:{' '}
                                <strong>
                                  {order[ORDER.DELIVERY]?.address?.apt}
                                </strong>{' '}
                              </>
                            )}
                            {order[ORDER.DELIVERY]?.address?.entrance && (
                              <>
                                Entrance:{' '}
                                <strong>
                                  {order[ORDER.DELIVERY]?.address?.entrance}
                                </strong>{' '}
                              </>
                            )}
                            {order[ORDER.DELIVERY]?.address?.floor && (
                              <>
                                Floor:{' '}
                                <strong>
                                  {order[ORDER.DELIVERY]?.address?.floor}
                                </strong>{' '}
                              </>
                            )}
                          </span>
                          {order[ORDER.DELIVERY]?.address?.notes && (
                            <>
                              <br />
                              <span>
                                Notes:{' '}
                                <strong>
                                  {order[ORDER.DELIVERY]?.address?.notes}
                                </strong>
                              </span>
                            </>
                          )}
                        </Body1>
                      )}

                      {deliveryStatus?.courier?.name && (
                        <Body1 className='block marginBottomLg'>
                          <span className='inlineBlock marginRightXs'>
                            Courier:
                          </span>
                          <strong>
                            {deliveryStatus?.courier?.name || 'N/A'}
                          </strong>
                        </Body1>
                      )}

                      {deliveryStatus?.courier?.vehicle && (
                        <Body1 className='block marginBottomLg'>
                          <span className='inlineBlock marginRightXs'>
                            Vehicle Description:
                          </span>
                          <strong>
                            {deliveryStatus?.courier?.vehicle || 'N/A'}
                          </strong>
                        </Body1>
                      )}

                      {order[ORDER.DELIVERY]?.isDispatch && (
                        <Body1 className='block marginBottomLg'>
                          <span className='inlineBlock marginRightXs'>
                            Delivery Reference Number:
                          </span>
                          <strong>
                            {dispatchInfo?.DeliveryReferenceNumber || 'N/A'}
                          </strong>
                        </Body1>
                      )}
                    </OrderRTop>
                  </OrderRSide>
                </FlexItem>
              </FlexContainer>
            </>
          </>
        )}
      </DashboardInner>

      {isOpenAdjustModal && (
        <AdjustOrderModal
          isOpen={isOpenAdjustModal}
          invoiceId={order[ORDER.INVOICE_ID]}
          orderId={order[ORDER.ID]}
        />
      )}
      {isOpenSuccessModal && <AdjustSuccessModal isOpen={isOpenSuccessModal} />}
      {isOpenErrorModal && (
        <AdjustErrorModal
          isOpen={isOpenErrorModal}
          errorMessage={errorMessage}
          errorTitle={errorTitle}
        />
      )}
      <CancelDeliveryOrderModal
        open={isOpenCancelDeliveryOrderModal}
        deliveryId={order[ORDER.DELIVERY]?.id}
        orderId={order[ORDER.OLD_ORDER_ID]}
        loadingCancellation={loadingCancellation}
      />
      <CancelDeliveryOrderResultModal
        open={deliveryCancellationResult.isOpenModal}
        message={deliveryCancellationResult.message}
      />
      <InfoModal
        openModal={openInfoModal}
        onClose={() => {
          setOpenInfoModal(false);
        }}
      />
      <DriverRatingViewModal
        isOpen={isDriverRatingViewModalOpen}
        onClose={() => setIsDriverRatingViewModalOpen(false)}
        driverName={deliveryStatus?.courier?.name}
        rating={driverRating}
        onModify={() => {
          setIsDriverRatingViewModalOpen(false);
          setIsRateDriverModalOpen(true);
        }}
      />
      <RateDriverModal
        isOpen={isRateDriverModalOpen}
        onClose={() => setIsRateDriverModalOpen(false)}
        deliveryStatus={deliveryStatus}
        order={order}
        deliveryId={order[ORDER.DELIVERY]?.id}
        existingRating={driverRating}
        sendDriverRateToPostHog={sendDriverRateToPostHog}
        activeLocation={activeLocation}
      />
      <ProofOfDeliveryModal
        isOpen={isProofOfDeliveryModalOpen}
        onClose={() => setIsProofOfDeliveryModalOpen(false)}
        proofOfDelivery={deliveryStatus?.proofOfDelivery}
        timezoneId={activeLocation?.TimezoneId}
      />
    </DashboardContent>
  );
}
